import { useMutation, useQuery, useQueryClient } from 'react-query'

// Libs
import { fetchCategoryPreference, updateCategoryPreference } from '@/api/fetchCategoryPreference'
import { useAppSelector } from '@/redux/hooks'

// Constants
import { QUERY_KEY } from '@/constants/queryKey'

// 會員偏好分類：未登入不打 API；儲存後更新快取並讓「為你推薦」重抓
export const useCategoryPreference = () => {
  const queryClient = useQueryClient()
  const memberInfoId = useAppSelector((state) => state.member?.memberData?.memberInfoId)
  const isLogin = !!memberInfoId

  const query = useQuery([QUERY_KEY.FETCH_CATEGORY_PREFERENCE, memberInfoId], fetchCategoryPreference, {
    enabled: isLogin,
    staleTime: 5 * 60 * 1000,
  })

  const mutation = useMutation(updateCategoryPreference, {
    onSuccess: (data) => {
      queryClient.setQueryData([QUERY_KEY.FETCH_CATEGORY_PREFERENCE, memberInfoId], data)
      queryClient.invalidateQueries([QUERY_KEY.FETCH_PRODUCT_RECOMMEND, { type: 'for-you' }])
    },
  })

  return {
    isLogin,
    preference: query.data,
    isFetched: query.isFetched,
    save: mutation.mutateAsync,
    isSaving: mutation.isLoading,
  }
}
